import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  PoApprovalBand, PoApprovalBandSetup, PoApprovalStatus, PoPrefill, RaisableRequisition,
} from '../interfaces/procurement/poApproval.interface';

export const PoApprovalService = {
  setup: async (institutionId: string): Promise<PoApprovalBandSetup> =>
    (await axios.get(ENDPOINTS.PO_APPROVAL.BANDS(institutionId))).data,
  /** Replaces the whole band set; the server validates it together (no gaps or overlaps). */
  replaceBands: async (institutionId: string, bands: PoApprovalBand[]): Promise<PoApprovalBandSetup> =>
    (await axios.put(ENDPOINTS.PO_APPROVAL.BANDS(institutionId), bands.map(b => ({
      sequenceNo: b.sequenceNo,
      minAmount: b.minAmount,
      maxAmount: b.maxAmount,
      approvalsRequired: b.approvalsRequired,
      requiredRoleId: b.requiredRoleId || null,
      requiredPermissionKey: b.requiredPermissionKey || null,
    })))).data,
  pending: async (institutionId: string): Promise<PoApprovalStatus[]> =>
    (await axios.get(ENDPOINTS.PO_APPROVAL.PENDING(institutionId))).data,
  ofPurchaseOrder: async (id: string): Promise<PoApprovalStatus> =>
    (await axios.get(ENDPOINTS.PO_APPROVAL.OF_PO(id))).data,
  raisableRequisitions: async (institutionId: string): Promise<RaisableRequisition[]> =>
    (await axios.get(ENDPOINTS.PO_APPROVAL.RAISABLE_REQUISITIONS(institutionId))).data,
  prefill: async (requisitionId: string): Promise<PoPrefill> =>
    (await axios.get(ENDPOINTS.PO_APPROVAL.PO_PREFILL(requisitionId))).data,
};
